import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'convertToUrl'
})
export class ConvertToUrlFilterPipe implements PipeTransform {
    transform(str: string){
        return str.replace(/\s+/g, '-').toLowerCase();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pipes/convertToUrl.filter.ts